import { collection, doc, getDoc, getDocs, limit, orderBy, query, where, type DocumentData, type QueryDocumentSnapshot } from 'firebase/firestore';
import { db } from '@/config/firebase';
import type { DpRequest, DpRequestMessage } from '../../../../shared/dpRequests';

const DP_REQUESTS = 'dpRequests';
const DP_QUEUE_LIMIT = 300;

function toRequest(snapshot: QueryDocumentSnapshot<DocumentData>): DpRequest {
    return { id: snapshot.id, ...snapshot.data() } as DpRequest;
}

function sortByCreatedDesc(items: DpRequest[]): DpRequest[] {
    return items.slice().sort((a, b) => b.createdAt.toDate().getTime() - a.createdAt.toDate().getTime());
}

export async function listMyDpRequests(email: string): Promise<DpRequest[]> {
    const snapshot = await getDocs(
        query(collection(db, DP_REQUESTS), where('collaboratorEmail', '==', email), orderBy('createdAt', 'desc'))
    );
    return snapshot.docs.map(toRequest);
}

export async function listDpQueue(): Promise<DpRequest[]> {
    const snapshot = await getDocs(query(collection(db, DP_REQUESTS), orderBy('createdAt', 'desc'), limit(DP_QUEUE_LIMIT)));
    return snapshot.docs.map(toRequest);
}

export async function listManagerDayOffs(managerEmail: string): Promise<DpRequest[]> {
    const snapshot = await getDocs(
        query(collection(db, DP_REQUESTS), where('type', '==', 'day_off'), where('managerEmail', '==', managerEmail))
    );
    return sortByCreatedDesc(snapshot.docs.map(toRequest));
}

export async function getDpRequest(requestId: string): Promise<DpRequest | null> {
    const snapshot = await getDoc(doc(db, DP_REQUESTS, requestId));
    if (!snapshot.exists()) return null;
    return { id: snapshot.id, ...snapshot.data() } as DpRequest;
}

export async function listDpMessages(requestId: string): Promise<DpRequestMessage[]> {
    const snapshot = await getDocs(
        query(collection(db, DP_REQUESTS, requestId, 'messages'), orderBy('createdAt', 'asc'))
    );
    return snapshot.docs.map(item => ({ id: item.id, ...item.data() } as DpRequestMessage));
}

export async function listDpRequestsOfCollaborator(collaboratorId: string): Promise<DpRequest[]> {
    const snapshot = await getDocs(query(collection(db, DP_REQUESTS), where('collaboratorId', '==', collaboratorId)));
    return snapshot.docs.map(toRequest);
}
